import mixitup from '../../Assets/MixItUp';

let activeHash = '';
let targetSelector = '.mix';
let mixer;

function deserializeHash() {
    let hash = window.location.hash.replace(/^#/g, '');
    let obj = null;
    let groups = [];

    if (!hash) {
        return obj;
    }

    obj = {};
    groups = hash.split('/');

    if (groups[0] && groups[0].length) {
        // category
        obj.category = groups[0].split(',');
    }

    if (groups[1] && groups[1].length) {
        // subcategory
        obj.subcategory = groups[1].split(',');
    }

    return obj;
}

function serializeGroupsState(groupsState) {
    let output = '';

    if (groupsState.category && groupsState.category[0]) {
        output += groupsState.category[0];
    }

    if (groupsState.subcategory && groupsState.subcategory.length) {
        output += '/';
        output += groupsState.subcategory.join(',');
    }

    return output;
}

function getValueFromSelector(selector) {
    return selector.replace(/^.-/, '');
}

function getGroupsState() {
    let groupsState = {
        category: mixer
            .getFilterGroupSelectors('category')
            .map(getValueFromSelector),
        subcategory: mixer
            .getFilterGroupSelectors('subcategory')
            .map(getValueFromSelector),
    };

    return groupsState;
}

function setHash(state) {
    let selector = state.activeFilter.selector;
    let groupsState = getGroupsState();
    let newHash = '#' + serializeGroupsState(groupsState);

    if (selector === targetSelector && window.location.hash) {
        // Equivalent to filter "all", remove the hash
        activeHash = '';
        history.pushState(null, document.title, window.location.pathname);
    } else if (
        newHash !== window.location.hash &&
        selector !== targetSelector
    ) {
        // Change the hash
        activeHash = newHash;
        history.pushState(
            null,
            document.title,
            window.location.pathname + newHash
        );
    }
}

function filterMixerByGroupsState(groupsState, animate) {
    let category =
        groupsState && groupsState.category ? groupsState.category : [];
    let subcategory =
        groupsState && groupsState.subcategory ? groupsState.subcategory : [];

    mixer.setFilterGroupSelectors(
        'category',
        category.map(getSelectorFromValue)
    );
    mixer.setFilterGroupSelectors(
        'subcategory',
        subcategory.map(getSelectorFromValue)
    );

    // Parse the filter groups (passing `false` will perform no animation)
    return mixer.parseFilterGroups(animate ? true : false);
}

function getSelectorFromValue(value) {
    return '.-' + value;
}

let groupsState = deserializeHash();

// comment out the following block of code, because it doesn't work on the live page, and with update we want the same behavior as before

// _gg.onReady.FAQContainer = function () {
//     let containerEl = document.querySelector('.faq-entries');

//     if (containerEl) {
//         mixer = mixitup(containerEl, {
//             animation: {
//                 //animateResizeTargets: true,
//                 animateResizeContainer: true,
//             },
//             multifilter: {
//                 enable: true,
//             },
//             callbacks: {
//                 onMixEnd: setHash, // Call the setHash() method at the end of each operation
//             },
//         });

//         if (groupsState) {
//             filterMixerByGroupsState(groupsState);
//         } else {
//             let value = document.querySelector('input[name="category"]:checked')
//                 .value;
//             if (value) {
//                 mixer.setFilterGroupSelectors('category', value);
//                 mixer.parseFilterGroups(false);
//             }
//         }

//         window.onhashchange = function () {
//             let groupsState = deserializeHash();
//             let hash = window.location.hash;

//             // Compare new hash with active hash
//             if (hash === activeHash) {
//                 // no change
//                 return;
//             }

//             activeHash = hash;
//             filterMixerByGroupsState(groupsState, true);
//         };
//     }
// };
